var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-right",
    width: 18,
    height: 18,
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3E4462",
    stroke: "#fafafa",
    style: {
      stroke: "var(--color1, #fafafa)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.1895,
    d: "M4.632 16h16.842M15.158 7.158l8.842 8.842-8.842 8.842"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "botbolt",
    viewBox: "0 0 55 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8baa36",
    style: {
      stroke: "var(--color2, #8baa36)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 9.1429,
    d: "M50.286 4.571l-22.857 22.857-22.857-22.857"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "burger",
    viewBox: "0 0 48 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 4,
    d: "M3 16h42M3 2h42M3 30h28"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "clock",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    fill: "transparent",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.9714,
    d: "M16 29.333c7.363 0 13.333-5.969 13.333-13.333s-5.969-13.333-13.333-13.333v0c-7.363 0-13.333 5.969-13.333 13.333s5.969 13.333 13.333 13.333v0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    fill: "black",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.9714,
    d: "M16 8v8l5.333 2.667"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "crossbolt",
    viewBox: "0 0 52 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8baa36",
    style: {
      fill: "var(--color2, #8baa36)"
    },
    d: "M41.413 14.638v0l-0.747 2.15c-0.005 0.014-0.008 0.031-0.008 0.048 0 0.037 0.014 0.072 0.037 0.098l-0-0 1.463 1.655c0.133 0.155 0.39 0.065 0.397-0.139l0.202-5.978c0-0.002 0-0.005 0-0.008 0-0.084-0.047-0.157-0.116-0.194l-0.001-0.001c-0.031-0.017-0.067-0.026-0.106-0.026-0.049 0-0.094 0.015-0.131 0.042l0.001-0-4.95 3.456c-0.059 0.040-0.097 0.107-0.097 0.183 0 0.114 0.086 0.208 0.196 0.22l0.001 0 2.207 0.294c0.006 0.001 0.013 0.001 0.020 0.001 0.048 0 0.091-0.023 0.119-0.058l0-0 1.409-1.798c0.011-0.014 0.028-0.023 0.047-0.023 0.010 0 0.020 0.003 0.029 0.007l-0-0c0.019 0.010 0.031 0.030 0.031 0.052 0 0.007-0.001 0.013-0.003 0.019l-0-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8baa36",
    style: {
      stroke: "var(--color2, #8baa36)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 0.8348,
    d: "M5.918 10.431c4.133 3.462 14.047 15.084 18.639 7.82 5.74-9.080-9.702-9.547-9.071-1.713s14.857 13.474 24.645 0.677"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "enjoybolt",
    viewBox: "0 0 40 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3e4462",
    style: {
      stroke: "var(--color3, #3e4462)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 4,
    d: "M4 16h32M36 16l-12-12M36 16l-12 12"
  })), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "face",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.316 16.091c0-8.421-6.787-15.249-15.158-15.249s-15.158 6.828-15.158 15.249c0 7.613 5.541 13.92 12.79 15.065v-10.654h-3.85v-4.413h3.85v-3.357c0-3.823 2.264-5.935 5.726-5.935 1.657 0 3.392 0.3 3.392 0.3v3.752h-1.912c-1.883 0-2.471 1.176-2.471 2.383v2.858h4.204l-0.672 4.409h-3.532v10.658c7.249-1.145 12.79-7.453 12.79-15.067z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "facetop",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8baa36",
    style: {
      fill: "var(--color2, #8baa36)"
    },
    d: "M32 16.097c0-8.89-7.164-16.097-16-16.097s-16 7.207-16 16.097c0 8.033 5.85 14.693 13.5 15.902v-11.248h-4.064v-4.652h4.064v-3.547c0-4.033 2.389-6.263 6.043-6.263 1.751 0 3.582 0.315 3.582 0.315v3.962h-2.018c-1.985 0-2.607 1.241-2.607 2.514v3.019h4.437l-0.709 4.654h-3.728v11.248c7.65-1.209 13.5-7.867 13.5-15.903z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "forkknife_bot",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8baa36",
    style: {
      stroke: "var(--color2, #8baa36)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.92,
    d: "M6.4 6.49v4.759c0 1.359 0.593 2.562 1.513 3.341 0.449 0.381 0.747 0.896 0.747 1.466v7.945c0 0.883 0.758 1.6 1.694 1.6s1.694-0.717 1.694-1.6v-7.945c0-0.571 0.298-1.085 0.747-1.466 0.919-0.779 1.513-1.982 1.513-3.341v0M10.352 11.733v-5.333M25.6 7.522c0-0.589-0.507-1.067-1.131-1.067h-1.13c-1.871 0-3.388 1.433-3.388 3.2v6.4c0 1.391 0.945 2.563 2.259 3.004v4.941c0 0.883 0.758 1.6 1.694 1.6s1.694-0.717 1.694-1.6v-16.478z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "forkknife_top",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fafafa",
    style: {
      stroke: "var(--color1, #fafafa)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M3.199 3.31v5.817c0 1.661 0.725 3.131 1.848 4.083 0.549 0.465 0.913 1.094 0.913 1.791v9.71c0 1.080 0.927 1.955 2.070 1.955s2.071-0.875 2.071-1.954v-9.711c0-0.697 0.363-1.326 0.912-1.791 1.125-0.952 1.849-2.423 1.849-4.083v0M8.029 9.719v-6.519M26.665 4.571c0-0.72-0.617-1.304-1.381-1.304h-1.379c-2.288 0-4.142 1.751-4.142 3.911v7.823c0 1.699 1.154 3.133 2.761 3.671v6.039c0 1.080 0.927 1.955 2.070 1.955s2.071-0.875 2.071-1.954v-20.141z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "forkknife_welc",
    viewBox: "0 0 44 44"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fafafa",
    style: {
      stroke: "var(--color1, #fafafa)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M8.5 8.132V15.213v-.14c0 1.982.865 3.737 2.206 4.873.655.555 1.088 1.305 1.088 2.137v11.586c0 1.288 1.107 2.334 2.47 2.334 1.365 0 2.471-1.046 2.471-2.334V22.083c0-.832.434-1.582 1.09-2.137 1.34-1.136 2.205-2.89 2.205-4.873v-6.94 6.94M14.26 15.778V8M36.5 9.636c0-.859-.738-1.555-1.647-1.555h-1.647c-2.73 0-4.941 2.089-4.941 4.666v9.334c0 2.029 1.378 3.738 3.294 4.38v7.206c0 1.288 1.107 2.334 2.47 2.334 1.364 0 2.471-1.046 2.471-2.334V9.637Z"
  })), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "insta",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.665 2.667c3.678 0.011 6.656 2.988 6.669 6.664v13.334c-0.011 3.679-2.99 6.659-6.668 6.669h-13.334c-3.677-0.013-6.655-2.991-6.665-6.668v-13.334c0.013-3.676 2.989-6.653 6.664-6.665h13.334zM22.665 0h-13.333c-5.148 0.016-9.317 4.185-9.333 9.331v13.334c0.015 5.149 4.184 9.319 9.331 9.335h13.334c5.149-0.015 9.32-4.185 9.335-9.333v-13.334c-0.016-5.149-4.186-9.318-9.333-9.333h-0.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.666 9.336c-0.018 0.001-0.040 0.001-0.061 0.001-1.105 0-2.001-0.896-2.001-2.001s0.896-2.001 2.001-2.001c0.022 0 0.043 0 0.064 0.001l-0.003-0c1.078 0.034 1.94 0.917 1.94 2s-0.861 1.966-1.936 2l-0.003 0zM16 10.669c2.946 0 5.334 2.388 5.334 5.334s-2.388 5.334-5.334 5.334v0c-2.946 0-5.334-2.388-5.334-5.334s2.388-5.334 5.334-5.334v0zM16 8.004c-4.418 0-8 3.582-8 8s3.582 8 8 8v0c4.418 0 8-3.582 8-8s-3.582-8-8-8v0z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "instatop",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8baa36",
    style: {
      fill: "var(--color2, #8baa36)"
    },
    d: "M22.667 2.667c3.677 0.011 6.655 2.989 6.667 6.666v13.334c-0.011 3.677-2.989 6.655-6.666 6.667h-13.334c-3.677-0.012-6.655-2.99-6.667-6.666v-13.335c0.011-3.677 2.989-6.655 6.666-6.667h13.334zM22.667 0h-13.333c-5.133 0-9.333 4.2-9.333 9.333v13.333c0 5.133 4.2 9.333 9.333 9.333h13.333c5.133 0 9.333-4.2 9.333-9.333v-13.333c0-5.133-4.2-9.333-9.333-9.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8baa36",
    style: {
      fill: "var(--color2, #8baa36)"
    },
    d: "M24.667 9.336c-1.105 0-2-0.895-2-2s0.895-2 2-2v0c1.105 0 2 0.895 2 2s-0.895 2-2 2v0zM16 10.669c2.946 0 5.333 2.388 5.333 5.333s-2.388 5.333-5.333 5.333v0c-2.946 0-5.333-2.388-5.333-5.333s2.388-5.333 5.333-5.333v0zM16 8.003c-4.418 0-8 3.582-8 8s3.582 8 8 8v0c4.418 0 8-3.582 8-8s-3.582-8-8-8v0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "leftbolt",
    viewBox: "0 0 17 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a9a9a9",
    style: {
      fill: "var(--color4, #a9a9a9)"
    },
    opacity: 0.73,
    d: "M16.309 2.255c0.468 0.478 0.757 1.133 0.757 1.856 0 0.006-0 0.012-0 0.018v-0.001c-0.001 0.728-0.29 1.388-0.758 1.874l0.001-0.001-10.059 10.313 10.057 10.31c0.484 0.497 0.755 1.171 0.755 1.873 0 0.704-0.271 1.376-0.755 1.873-0.463 0.478-1.111 0.775-1.828 0.777h-0c-0.685 0-1.344-0.277-1.826-0.777l-11.895-12.194c-0.468-0.478-0.757-1.133-0.757-1.856 0-0.008 0-0.015 0-0.023v0.001c0.001-0.728 0.29-1.388 0.758-1.874l-0.001 0.001 11.898-12.198c0.464-0.465 1.105-0.753 1.814-0.753 0.722 0 1.375 0.299 1.84 0.78l0.001 0.001z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "mail",
    viewBox: "0 0 41 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fafafa",
    style: {
      stroke: "var(--color1, #fafafa)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.7429,
    d: "M5.943 2.286h29.257c0.969 0.002 1.897 0.366 2.583 1.006 0.686 0.645 1.072 1.515 1.074 2.423v20.571c-0.002 0.91-0.389 1.778-1.074 2.423-0.686 0.64-1.614 1.003-2.583 1.006h-29.257c-0.003 0-0.006 0-0.010 0-0.994 0-1.899-0.382-2.576-1.008l0.003 0.002c-0.655-0.605-1.066-1.465-1.074-2.421v-20.573c0.002-0.907 0.389-1.778 1.074-2.423 0.686-0.64 1.614-1.003 2.583-1.006v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fafafa",
    style: {
      stroke: "var(--color1, #fafafa)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.7429,
    d: "M38.857 5.714l-18.286 12-18.286-12"
  })), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "pencil",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.7733,
    d: "M3.471 24.602c0.098-0.881 0.147-1.323 0.279-1.734 0.129-0.394 0.298-0.737 0.507-1.050l-0.010 0.016c0.239-0.363 0.555-0.676 1.18-1.303l15.729-15.729c0.637-0.637 1.517-1.032 2.49-1.032s1.853 0.394 2.49 1.032v0c0.637 0.637 1.030 1.517 1.030 2.489s-0.394 1.852-1.030 2.489l-15.729 15.729c-0.627 0.629-0.943 0.943-1.303 1.18-0.298 0.199-0.64 0.368-1.005 0.488l-0.030 0.009c-0.412 0.134-0.853 0.183-1.737 0.282l-3.219 0.358 0.358-3.221z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "pick",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8baa36",
    style: {
      fill: "var(--color2, #8baa36)"
    },
    d: "M24.877 3.238c0.51-0.745 1.356-1.227 2.315-1.227 1.545 0 2.798 1.253 2.798 2.798 0 0.587-0.18 1.131-0.489 1.581l0.006-0.010-15.174 22.381c-0.51 0.745-1.356 1.228-2.315 1.228s-1.805-0.483-2.309-1.218l-0.006-0.010-7.206-10.634c-0.282-0.429-0.449-0.955-0.449-1.52 0-1.545 1.252-2.797 2.797-2.797 0.939 0 1.77 0.463 2.277 1.173l0.006 0.008 4.893 7.213 12.858-18.966z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "rightbolt",
    viewBox: "0 0 17 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a9a9a9",
    style: {
      fill: "var(--color4, #a9a9a9)"
    },
    opacity: 0.73,
    d: "M0.757 2.255c-0.468 0.478-0.757 1.133-0.757 1.856 0 0.006 0 0.012 0 0.018v-0.001c0.001 0.728 0.29 1.388 0.758 1.874l-0.001-0.001 10.059 10.313-10.059 10.31c-0.467 0.482-0.755 1.141-0.755 1.866 0 0.002 0 0.005 0 0.007v-0c0 0.704 0.271 1.376 0.755 1.873s1.143 0.777 1.828 0.777c0.685 0 1.344-0.277 1.826-0.777l11.898-12.194c0.468-0.478 0.757-1.133 0.757-1.856 0-0.008-0-0.015-0-0.023v0.001c-0.001-0.728-0.29-1.388-0.758-1.874l0.001 0.001-11.898-12.198c-0.464-0.465-1.105-0.753-1.814-0.753-0.722 0-1.375 0.299-1.84 0.78l-0.001 0.001z"
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M14.667 25.333c5.891 0 10.667-4.776 10.667-10.667s-4.776-10.667-10.667-10.667v0c-5.891 0-10.667 4.776-10.667 10.667s4.776 10.667 10.667 10.667v0zM28 28l-5.8-5.8"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "trash",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fafafa",
    style: {
      stroke: "var(--color1, #fafafa)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.7429,
    d: "M21.333 8v-1.067c0-1.493 0-2.24-0.29-2.811-0.261-0.504-0.662-0.905-1.151-1.159l-0.015-0.007c-0.571-0.288-1.317-0.288-2.811-0.288h-2.133c-1.493 0-2.24 0-2.811 0.29-0.501 0.256-0.907 0.663-1.166 1.166-0.288 0.571-0.288 1.317-0.288 2.811v1.065M13.333 15.333v6.667M18.667 15.333v6.667M4 8h24M25.333 8v14.933c0 2.24 0 3.36-0.434 4.217-0.391 0.756-0.992 1.358-1.726 1.738l-0.022 0.011c-0.857 0.434-1.977 0.434-4.217 0.434h-5.865c-2.24 0-3.36 0-4.217-0.434-0.756-0.391-1.358-0.992-1.738-1.726l-0.011-0.022c-0.434-0.855-0.434-1.977-0.434-4.217v-14.933"
  })), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "twitter",
    viewBox: "0 0 38 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4 4.606c-1.317 0.573-2.846 0.992-4.444 1.183l-0.078 0.008c1.613-0.924 2.836-2.376 3.446-4.115l0.016-0.053c-1.443 0.835-3.122 1.469-4.904 1.81l-0.101 0.016c-0.729-0.741-1.601-1.339-2.572-1.749l-0.052-0.020c-0.919-0.391-1.988-0.619-3.11-0.619-0.005 0-0.011 0-0.016 0h0.001c-4.356 0-7.878 3.375-7.878 7.537-0.002 0.578 0.064 1.156 0.205 1.719-3.292-0.153-6.358-0.976-9.112-2.334l0.135 0.060c-2.861-1.404-5.277-3.29-7.239-5.576l-0.025-0.030c-0.67 1.079-1.068 2.387-1.071 3.788v0.001c0 2.613 1.402 4.924 3.52 6.276-1.317-0.030-2.547-0.375-3.626-0.962l0.042 0.021v0.094c0 3.654 2.722 6.697 6.321 7.388-0.622 0.168-1.337 0.264-2.073 0.265h-0c-0.499 0-0.994-0.045-1.483-0.141 1.003 2.995 3.915 5.173 7.364 5.235-2.678 2.015-6.060 3.228-9.725 3.228-0.021 0-0.042-0-0.064-0h0.003c-0.627 0-1.257-0.036-1.879-0.107 3.404 2.137 7.542 3.405 11.976 3.405 0.030 0 0.059-0 0.089-0h-0.005c14.507 0 22.434-11.488 22.434-21.451 0-0.326-0.009-0.653-0.023-0.973 1.544-1.074 2.846-2.368 3.897-3.853l0.033-0.049z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "twittertop",
    viewBox: "0 0 36 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8baa36",
    style: {
      fill: "var(--color2, #8baa36)"
    },
    d: "M36.364 3.792c-1.244 0.612-2.689 1.059-4.21 1.266l-0.074 0.008c1.552-0.999 2.72-2.588 3.281-4.465-1.358 0.89-2.944 1.568-4.645 1.941l-0.094 0.017c-0.679-0.786-1.506-1.424-2.439-1.876l-0.045-0.020c-0.866-0.419-1.884-0.663-2.958-0.663-0.002 0-0.003 0-0.005 0h0c-4.124 0-7.459 3.616-7.459 8.076-0 0.013-0 0.028-0 0.044 0 0.637 0.070 1.258 0.203 1.854l-0.011-0.057c-3.143-0.173-6.046-1.055-8.598-2.488l0.1 0.051c-2.647-1.455-4.992-3.5-6.88-6.006-0.638 1.172-1.014 2.566-1.014 4.048 0 0.004 0 0.007 0 0.011v-0.001c0 2.8 1.328 5.276 3.332 6.726-1.26-0.038-2.425-0.408-3.421-1.026l0.029 0.017v0.102c0 3.916 2.575 7.174 5.985 7.916-0.641 0.188-1.302 0.282-1.965 0.284-0.471 0-0.941-0.049-1.402-0.151 0.947 3.209 3.705 5.542 6.973 5.609-2.656 2.252-5.916 3.468-9.267 3.459-0.629-0.002-1.247-0.044-1.852-0.126l0.072 0.008c3.409 2.396 7.375 3.663 11.42 3.651 13.74 0 21.245-12.308 21.245-22.983 0-0.349-0.007-0.7-0.023-1.041 1.472-1.166 2.71-2.55 3.683-4.116l0.039-0.068z"
  })), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "x",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.5263,
    d: "M23.685 7.475l-17.054 17.053M23.685 24.527l-17.054-17.054"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "yotubetop",
    viewBox: "0 0 41 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8baa36",
    style: {
      fill: "var(--color2, #8baa36)"
    },
    d: "M40.465 7.066c0-3.75-2.633-6.767-5.887-6.767-4.407-0.217-8.902-0.3-13.497-0.3h-1.431c-4.582 0-9.085 0.083-13.492 0.3-3.247 0-5.879 3.034-5.879 6.784-0.178 2.548-0.28 5.522-0.28 8.519 0 0.133 0 0.267 0.001 0.4l-0-0.021c-0.007 2.967 0.083 5.935 0.271 8.908 0 3.75 2.633 6.793 5.879 6.793 4.63 0.224 9.38 0.324 14.209 0.316 4.836 0.016 9.572-0.089 14.208-0.317 3.254 0 5.887-3.041 5.887-6.791 0.192-2.975 0.279-5.942 0.271-8.916 0.019-2.967-0.068-5.936-0.259-8.908zM16.468 24.157v-16.375l11.535 8.183-11.535 8.192z"
  })), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "youtube",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.15 7.065c0-3.749-2.809-6.766-6.279-6.766-4.699-0.217-9.49-0.299-14.391-0.299h-1.527c-4.885 0-9.685 0.082-14.386 0.299-3.461 0-6.27 3.033-6.27 6.786-0.19 2.546-0.298 5.516-0.298 8.511 0 0.135 0 0.271 0.001 0.406l-0-0.021c-0 0.107-0.001 0.234-0.001 0.36 0 3.008 0.105 5.991 0.311 8.946l-0.022-0.398c0 3.751 2.809 6.793 6.27 6.793 4.937 0.224 10.002 0.325 15.152 0.315 5.157 0.018 10.208-0.089 15.15-0.315 3.47 0 6.279-3.042 6.279-6.793 0.203-2.974 0.297-5.941 0.288-8.914 0.002-0.227 0.002-0.496 0.002-0.765 0-2.866-0.101-5.708-0.301-8.523l0.022 0.379zM17.561 24.16v-16.377l12.299 8.183-12.299 8.192z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "reg-name",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M15 16.25c0-1.047 0-1.57-.13-1.996a3 3 0 0 0-2-2c-.425-.129-.948-.129-1.995-.129h-3.75c-1.047 0-1.57 0-1.996.13a3 3 0 0 0-2 2C3 14.68 3 15.202 3 16.25m9.375-10.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Z",
    opacity: 0.8
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "reg-email",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m1.5 5.75 6.124 4.287c.496.347.744.52 1.013.587.238.06.488.06.726 0 .27-.067.517-.24 1.013-.587L16.5 5.75M5.1 15.5h7.8c1.26 0 1.89 0 2.371-.245.424-.216.768-.56.984-.984.245-.48.245-1.11.245-2.371V7.1c0-1.26 0-1.89-.245-2.371a2.25 2.25 0 0 0-.983-.984C14.79 3.5 14.16 3.5 12.9 3.5H5.1c-1.26 0-1.89 0-2.371.245a2.25 2.25 0 0 0-.984.984C1.5 5.209 1.5 5.839 1.5 7.1v4.8c0 1.26 0 1.89.245 2.371.216.424.56.768.984.984.48.245 1.11.245 2.371.245Z",
    opacity: 0.8
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "reg-pass",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12.75 8.75V6.5a3.75 3.75 0 1 0-7.5 0v2.25m.6 7.5h6.3c1.26 0 1.89 0 2.371-.245.424-.216.768-.56.984-.983.245-.482.245-1.112.245-2.372v-.3c0-1.26 0-1.89-.245-2.371a2.25 2.25 0 0 0-.984-.984c-.48-.245-1.11-.245-2.371-.245h-6.3c-1.26 0-1.89 0-2.371.245a2.25 2.25 0 0 0-.984.984c-.245.48-.245 1.11-.245 2.371v.3c0 1.26 0 1.89.245 2.371.216.424.56.768.984.984.48.245 1.11.245 2.371.245Z",
    opacity: 0.8
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "input-succ",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10Zm14.523-1.727a1.096 1.096 0 0 0 0-1.546 1.096 1.096 0 0 0-1.546 0L8.75 10.953 7.023 9.227a1.096 1.096 0 0 0-1.546 0 1.096 1.096 0 0 0 0 1.546l2.5 2.5a1.096 1.096 0 0 0 1.546 0l5-5Z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "input-err",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10Zm6.836-1.871 1.84 1.836-1.84 1.87c-.363.368-.363.962 0 1.294.367.398.96.398 1.293 0l1.836-1.805 1.87 1.805c.368.398.962.398 1.294 0 .398-.332.398-.926 0-1.293l-1.805-1.871 1.805-1.836c.398-.332.398-.926 0-1.293-.332-.363-.926-.363-1.293 0l-1.871 1.84-1.836-1.84c-.332-.363-.926-.363-1.293 0-.363.367-.363.96 0 1.293Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.3f199c5d95ecb86872123f8e8b86d1e0.svg";
export { ForwardRef as ReactComponent };